import { render, staticRenderFns } from "./ServiceDown.vue?vue&type=template&id=2e0e4b9f"
import script from "./ServiceDown.vue?vue&type=script&lang=js"
export * from "./ServiceDown.vue?vue&type=script&lang=js"
import style0 from "./ServiceDown.vue?vue&type=style&index=0&id=2e0e4b9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports